import { ConsentsLedger, LegalConsent, OnConsentChange } from '../LegalConsents.types';

export interface ConsentsListProps {
  consentState: ConsentsState;
  validateErrors: boolean;
  onConsentChange: OnConsentChange;
}

export enum ConsentErrorType {
  NONE = 'none',
  NO_ENTRIES_FOUND = 'noEntriesFound',
  INTERNAL_VALIDATION_ERROR = 'internalValidationError',
  ALL_REQUIRED_CONSENTS_NOT_SELECTED = 'allRequiredConsentsNotSelected',
}

export interface ConsentError {
  type: ConsentErrorType;
  message: string | null;
}

export type ConsentsSectionTypes = Record<string, unknown>;

export interface ConsentsState {
  list: LegalConsent[];
  sectionTypes: ConsentsSectionTypes;
  consentsLedger: ConsentsLedger;
  error: ConsentError;
}

export type ConsentsCheckListModalInfo = {
  showModal: boolean;
  modalHeader: string;
  modalBody: Element | string;
};
